import { render, staticRenderFns } from "./KamilView.vue?vue&type=template&id=750cc8b0&scoped=true"
import script from "./KamilView.vue?vue&type=script&lang=js"
export * from "./KamilView.vue?vue&type=script&lang=js"
import style0 from "./KamilView.vue?vue&type=style&index=0&id=750cc8b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750cc8b0",
  null
  
)

export default component.exports